import { getCsrfCookie } from "../lib/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LOGIN_STATUS_QUERY_KEY, LoginStatus } from "./useLoginStatus";
import { USER_SETTINGS_QUERY_KEY } from "./useUserSettings";
import { USER_PROFILE_QUERY_KEY } from "./useUserProfile";

export function useLogin() {
  const queryClient = useQueryClient();

  const logoutMutation = useMutation({
    mutationFn: logout,
    onSuccess: (data) => {
      queryClient.setQueryData([LOGIN_STATUS_QUERY_KEY], data);
      queryClient.removeQueries({ queryKey: [USER_SETTINGS_QUERY_KEY] });
      queryClient.removeQueries({ queryKey: [USER_PROFILE_QUERY_KEY] });
    },
  });

  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      queryClient.setQueryData([LOGIN_STATUS_QUERY_KEY], data);
    },
  });

  return { logoutMutation, loginMutation };
}

async function logout(): Promise<LoginStatus> {
  const res = await fetch("/accounts/logout/", {
    method: "POST",
    headers: {
      "X-CSRFTOKEN": getCsrfCookie(),
    },
  });
  if (!res.ok) {
    throw new Error("could not log out.");
  }
  return { state: "logged out" };
}

async function login(args: {
  username: string;
  password: string;
}): Promise<LoginStatus> {
  const res = await fetch("/api/login/", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      username: args.username.trim(),
      password: args.password,
    }),
  });
  if (!res.ok) {
    throw new Error("could not log in user");
  }

  const data = await res.json();

  return { ...data, state: "logged in" };
}
